import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'
import Utility from '@/utils/Utility'

export default {
  name: 'Verification',
  components: {
    Loading
  },
  metaInfo () {
    let title = '二段階認証' + ' | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      inpPasscode: '',
      processing: false
    }
  },
  beforeMount () {
    if (this.authorized)
      this.$router.push({name: 'Home'})
  },
  computed: {
    ...mapState({
      authorized: state => state.auth.authorized
    }),
    ...mapGetters({
      getMeta: 'meta/get'
    }),

    // validate
    inpPasscodeIsValid () {
      return Validator.validText(this.inpPasscode)
    },
    formIsValid () {
      return this.inpPasscodeIsValid
    },
    disableConfirmButton () {
      if (this.processing) return true
      return !Validator.validText(this.inpPasscode)
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      verify: 'auth/verify',
      showError: 'error/show'
    }),
    clickVerify () {
      if (!this.formIsValid) return
      this.processing = true

      // ログイン
      this.verify({
        code: this.inpPasscode
      })
        .then(res => {
          console.log('clickVerify:success', res)
          this.processing = false
          
          this.$router.push(
            this.$route.query.redirect ||
            {
              name: 'Home'
            }
          )

        })
        .catch(error => {
          console.log('clickVerify:error', error)
          this.showError(error || null)
          this.processing = false
        })
    }
  }
}